var _a, _b, _c, _d;
import { generateActions } from "../generators/generator.actions";
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./documentPackage.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["CreateDocumentPackage"] = "CREATE_DOCUMENT_PACKAGE";
    EActionCustom["RevokeDocumentPackage"] = "REVOKE_DOCUMENT_PACKAGE";
    EActionCustom["RemindDocumentPackageSigner"] = "REMIND_DOCUMENT_PACKAGE_SIGNER";
})(EActionCustom || (EActionCustom = {}));
var generateCreateDocumentPackageActions = function () { return ({
    createDocumentPackageStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreateDocumentPackage,
        state: EActionState.Start,
    }),
    createDocumentPackageSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreateDocumentPackage,
        state: EActionState.Success,
    }),
    createDocumentPackageFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreateDocumentPackage,
        state: EActionState.Fail,
    }),
}); };
var generateRevokeDocumentPackageActions = function () { return ({
    revokeDocumentPackageStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RevokeDocumentPackage,
        state: EActionState.Start,
    }),
    revokeDocumentPackageSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RevokeDocumentPackage,
        state: EActionState.Success,
    }),
    revokeDocumentPackageFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RevokeDocumentPackage,
        state: EActionState.Fail,
    }),
}); };
var generateRemindDocumentPackageSignerActions = function () { return ({
    remindDocumentPackageSignerStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemindDocumentPackageSigner,
        state: EActionState.Start,
    }),
    remindDocumentPackageSignerSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemindDocumentPackageSigner,
        state: EActionState.Success,
    }),
    remindDocumentPackageSignerFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemindDocumentPackageSigner,
        state: EActionState.Fail,
    }),
}); };
export var createDocumentPackageStart = (_a = generateCreateDocumentPackageActions(), _a.createDocumentPackageStart), createDocumentPackageSucceeded = _a.createDocumentPackageSucceeded, createDocumentPackageFailed = _a.createDocumentPackageFailed;
export var revokeDocumentPackageStart = (_b = generateRevokeDocumentPackageActions(), _b.revokeDocumentPackageStart), revokeDocumentPackageSucceeded = _b.revokeDocumentPackageSucceeded, revokeDocumentPackageFailed = _b.revokeDocumentPackageFailed;
export var remindDocumentPackageSignerStart = (_c = generateRemindDocumentPackageSignerActions(), _c.remindDocumentPackageSignerStart), remindDocumentPackageSignerSucceeded = _c.remindDocumentPackageSignerSucceeded, remindDocumentPackageSignerFailed = _c.remindDocumentPackageSignerFailed;
export var getAllWhereStart = (_d = generateActions(GENERATOR_PARAMS), _d.getAllWhereStart), getDetailStart = _d.getDetailStart, getDetailSucceeded = _d.getDetailSucceeded, getDetailFailed = _d.getDetailFailed, getPagedStart = _d.getPagedStart, getPagedFailed = _d.getPagedFailed, getPagedSucceeded = _d.getPagedSucceeded, getCountStart = _d.getCountStart, getCountFailed = _d.getCountFailed, getCountSucceeded = _d.getCountSucceeded, createSucceeded = _d.createSucceeded;
